<template>
  <div class="wrapper">

    <side-bar type="sidebar" title="Qualification Check" :backgroundColor="$sidebar.sidebarBackground" :fontColor="$sidebar.sidebarFont" :activeColor="$sidebar.sidebarActive" :sidebar-links="$sidebar.sidebarLinks">
      <!--
      <form class="navbar-form navbar-left navbar-search-form navbar-search-form-mobile" role="search">
        <div class="input-group">
          <span class="input-group-addon"><i class="fa fa-search"></i></span>
          <input type="text" value="" class="form-control" placeholder="Search...">
        </div>
      </form>
      -->
    </side-bar>

    <div class="main-panel">
    <!--
      <div style="position: absolute; left: calc(50% - 50px); top: calc(50% - 50px)">
        <i class="qc-spinner" /><br/>Loading
      </div>
      -->
      <top-navbar></top-navbar>

      <content-body @click.native="toggleSidebar">

      </content-body>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="scss">

</style>
<script>
  import TopNavbar from './TopNavbar.vue'
  import ContentFooter from './ContentFooter.vue'
  import ContentBody from './ContentBody.vue'
  import MovingArrow from 'src/components/SidebarPlugin/MovingArrow.vue'
  import UserMenu from 'src/components/SidebarPlugin/UserMenu.vue'
  import MobileMenu from 'src/components/SidebarPlugin/MobileMenu.vue'

  import ModalTCSUpdate from 'src/components/ModalPlugin/ModalTCSUpdate'
  import ModalNewAppAck from 'src/components/ModalPlugin/ModalNewAppAck'

  import moment from 'moment'

  export default {
    components: {
      TopNavbar,
      ContentFooter,
      ContentBody,
      MovingArrow,
      UserMenu,
      MobileMenu
    },
    mounted () {
      if(this.$store.state.interuptMessageAck && moment(this.$store.state.interuptMessageAck).isBefore(moment('2018-10-30'))) {
        this.$modal.show(ModalNewAppAck)
      }
      if(this.$store.state.tcsVersion < this.$service.getLatestTcsVersion()) {
        this.$modal.show(ModalTCSUpdate)
      }
      // Note only the LAST modal shows up.
    },
    methods: {
      toggleSidebar () {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false)
        }
      }
    }
  }

</script>
